import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Box,
  Grid,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTable from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  getAllSupplier,
  getLocations,
  getStockAdjust,
} from "../../../redux/reducers/clinicSlice";
import { AppColors } from "../../../util/AppColors";
import { StockAdjustList } from "../../../util/arrayList";
import { plusBtn } from "../../../util/CommonIconStyle";
import { tblGrayBack } from "../../../util/object";
import StockAdjustment from "../../CommonScreens/Stock/StockAdjustment";

const tblHdrs = [
  "adjustId",
  "type",
  "remarks",
  "supplierCustomer",
  "date",
  "details",
  "view",
];
const viewTblHdrs = [
  "product",
  "adjustedQuantity",
  "uom",
  "batchNumber",
  "location",
];
const nameExpan = {
  adjustId: "#",
  type: "Type",
  remarks: "Reference / Reason",
  supplierCustomer: "Supplier/Customer Name",
  date: "Date",
  details: "Details",
  view: "",
};

const AdjustmentHistory = () => {
  const dispatch = useDispatch();
  const fetchRef = useRef(false);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [modVsble, setModVsble] = useState(false);
  const [modValues, setModValues] = useState({});
  const [viewModVsble, setViewModVsble] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(1);
  const [adjustModVsble, setAdjustModVsble] = useState(false);
  const itemSize = 10;
  const {
    stockAdjust,
    stocksByFilter,
    allSuppliers,
    selectedClinicBranch,
    users,
    locationList,
  } = useSelector((state) => state?.clinic);
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { stocks: clinicStocks } = useMemo(() => {
    if (!mandateDataRaw) {
      return { stocks: [] };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        stocks: Array.isArray(reqData?.stocks) ? reqData?.stocks : [],
      };
    } catch {
      return { stocks: [] };
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    onApiCall();
  }, [dispatch, searchValue, selectedFilter]);

  useEffect(() => {
    if (fetchRef.current) return;
    if (profile?.role === "ROLE_DOCTOR") {
      if (!selectedClinicBranch?.branchId) return;
      fetchRef.current = true;
      const reqUrl = `?clinicId=${selectedClinicBranch?.branchId}`;
      dispatch(getAllSupplier(reqUrl));
      dispatch(getLocations(reqUrl));
      return;
    }
    fetchRef.current = true;
    dispatch(getAllSupplier());
    dispatch(getLocations());
  }, [selectedClinicBranch, profile, dispatch]);

  const onApiCall = (pge = 1) => {
    setPage(pge);
    let reqUrl = `?page=${pge}&itemSize=${itemSize}`;
    if (searchValue?.length > 0) reqUrl += `&search=${searchValue}`;
    if (selectedFilter?.value) reqUrl += `&type=${selectedFilter?.value}`;
    dispatch(getStockAdjust(reqUrl));
  };

  const tableList = () => {
    const reqList = (stockAdjust?.data ?? [])?.map((li) => {
      const reqQty = (li?.stockAdjustDetails ?? [])?.reduce((acc, obj) => {
        return acc + (Number(obj?.quantity) ?? 0);
      }, 0);
      return {
        ...li,
        date: moment(new Date(li?.createdDate)).format("DD MMM YYYY"),
        supplierCustomer: li?.supplierName ?? li?.customerName ?? "",
        details: `${Math.abs(reqQty)} items adjusted`,
      };
    });
    return reqList;
  };

  const onCloseMod = (typ) => {
    setAdjustModVsble(false);
    if (typ === "apiSuccess") onApiCall();
  };

  const onSelectInvoice = (inv) => {
    setSelectedInvoice(inv);
    setModVsble(true);
  };

  const handleChangePage = (e, selectedPage) => {
    onApiCall(selectedPage);
  };

  const handleCreate = () => {
    setAdjustModVsble(true);
  };

  const getUOMListByStockId = (stkId = null) => {
    if (!stkId) return [];
    const stockMat = clinicStocks?.find((stc) => stc?.stockId === stkId);
    if (!stockMat) return [];
    const reqList = stockMat?.uomMappings
      ?.filter((ml) => ml?.allowSale === "Y" && ml?.show)
      ?.map((ml) => ({
        name: ml?.unit,
        value: ml?.unit,
        uomMappingId: ml?.uomMappingId ?? null,
      }));
    return reqList;
  };

  const handleView = (itm) => {
    setSelectedItem(itm);
    setViewModVsble(true);
  };

  const onCloseViewMod = () => {
    setViewModVsble(false);
    setSelectedItem(null);
  };

  const getTableList = () => {
    if (!selectedItem) return [];
    const reqList = (selectedItem?.stockAdjustDetails ?? [])?.map((li) => ({
      product: li?.productName ?? "",
      adjustedQuantity: li?.quantity ?? "",
      uom: li?.uomName ?? "",
      batchNumber: li?.batchNumber ?? "",
      location: li?.locationName ?? "",
    }));
    return reqList;
  };

  return (
    <>
      <div className="com-mar back-white pv10">
        <div className="flex-row-ali-cen w100Per">
          <div className="flex1-start" />
          <div className="flex-row-ali-cen">
            <div style={{ width: "400px" }}>
              <CustomTextField
                placeholder="Search"
                fullWidth
                backgroundColor={AppColors.lightBlue2}
                value={searchValue}
                handleChange={(e) => setSearchValue(e.target.value)}
              />
            </div>
            <div className="ml10">
              <CustomButton text="Create" smallBtn onClick={handleCreate} />
            </div>
          </div>
          <div className="flex1-end">
            <div className="w70Per">
              <CustomSelect
                list={StockAdjustList}
                fullWidth
                value={selectedFilter}
                handleChange={(e, value) => setSelectedFilter(value)}
                search
                label="Type"
              />
            </div>
          </div>
        </div>

        <div className="ml20">
          <Typography className="font-medium fs12 gray28">
            Number of count: {stockAdjust?.totalRecords ?? 0}
          </Typography>
        </div>
        <Box className="ph20">
          <TableContainer sx={{ maxHeight: 470 }} className="mb20 mt10">
            <Table
              sx={{ minWidth: 200 }}
              aria-labelledby="tableTitle"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  {tblHdrs?.map((hdr, i) => (
                    <TableCell
                      style={tblGrayBack}
                      className="txt-semi-bold fs12"
                      key={hdr + i}
                    >
                      <div>{nameExpan?.[hdr]}</div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {tableList()?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={12} className="text-align-center h100">
                    <div className="no-rec">No records available</div>
                  </TableCell>
                </TableRow>
              )}
              <TableBody>
                {tableList()?.map((li, ind) => {
                  return (
                    <TableRow>
                      {tblHdrs?.map((hdr, i) => {
                        return (
                          <TableCell key={`${ind} + ${i} + tr`} component="th">
                            <div>
                              {hdr === "supplier" ? (
                                <Custom3dotString
                                  str={li?.[hdr]}
                                  className="font-regular fs14"
                                />
                              ) : hdr === "invoice" ? (
                                <div
                                  className="cursor"
                                  onClick={() => onSelectInvoice(li)}
                                >
                                  <Custom3dotString
                                    str={li?.[hdr]}
                                    className="font-regular fs14 blue4"
                                  />
                                </div>
                              ) : hdr === "view" ? (
                                <div
                                  className="cursor"
                                  onClick={() => handleView(li)}
                                >
                                  <div className="flex-center">
                                    <VisibilityIcon sx={plusBtn} />
                                  </div>
                                  <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                    View
                                  </Typography>
                                </div>
                              ) : (
                                li?.[hdr]
                              )}
                            </div>
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
              {Math.ceil((stockAdjust?.totalRecords ?? 0) / itemSize) > 1 ? (
                <TableFooter>
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div className="flex-end">
                        <Pagination
                          count={Math.ceil(
                            (stockAdjust?.totalRecords ?? 0) / itemSize,
                          )}
                          variant="outlined"
                          color="primary"
                          page={page}
                          onChange={handleChangePage}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              ) : null}
            </Table>
          </TableContainer>
        </Box>
      </div>

      {adjustModVsble ? (
        <StockAdjustment modVsble={adjustModVsble} onCloseMod={onCloseMod} />
      ) : null}

      <CustomModal
        open={viewModVsble}
        onClose={onCloseViewMod}
        header="Stock Adjustment"
        headerCenter
        modalWidth={90}
        modal
      >
        <div className="scroll-80vh">
          <Grid container spacing={2} className="mt5 ph20">
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <CustomTextField
                label="Type"
                disabled
                fullWidth
                value={selectedItem?.type ?? ""}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <CustomTextField
                label="Date"
                disabled
                fullWidth
                mobileDate
                value={selectedItem?.createdDate}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <CustomTextField
                label="Remarks"
                disabled
                fullWidth
                value={selectedItem?.remarks}
              />
            </Grid>
          </Grid>
          <CustomTable columns={viewTblHdrs} datas={getTableList()} grey />
        </div>
      </CustomModal>
    </>
  );
};

export default AdjustmentHistory;
